module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_9006.c89b2a86.png";